import { render, staticRenderFns } from "./BuildUsageCode.vue?vue&type=template&id=04efa54b&scoped=true"
import script from "./BuildUsageCode.vue?vue&type=script&lang=js"
export * from "./BuildUsageCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efa54b",
  null
  
)

export default component.exports